import React from 'react';
import { useTranslation } from 'react-i18next';
import { sendTrackingInfo } from '@panel/commons';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import { BulkActionIcon, BulkActionIconContainer, BulkActionContainer, BulkActionText } from '../styles';

const UpdateResponsible = ({ postings, setBulkActionsModals, bulkActionsModals, device, userCanEditResponsible }) => {
  const { t } = useTranslation();

  // Se filtran los postings que han sido seleccionados (checked === true):
  const checkedPostings = postings && postings.filter(item => item.checked);

  // Se valida tipo de usuario y publicador, que almenos se haya seleccionado un posting y en caso de ser más de uno, tengan el mismo publisherId (misma sucursal):
  const updateResponsibleAvailable =
    userCanEditResponsible &&
    checkedPostings.length > 0 &&
    checkedPostings.every(item => item.publisherId === checkedPostings[0].publisherId);

  const postingsToUpdateResponsible = updateResponsibleAvailable
    ? postings.reduce((updateResponsibleArray, currentPosting) => {
        // Se arma y retorna el array con los postingId's que se enviarán al UpdateResponsibleModal:
        if (currentPosting.checked && !currentPosting.postingFull)
          updateResponsibleArray.push(currentPosting.postingId);
        return updateResponsibleArray;
      }, [])
    : [];

  if (updateResponsibleAvailable) {
    return (
      <BulkActionContainer
        onClick={() => {
          setBulkActionsModals({
            ...bulkActionsModals,
            responsible: { open: true, postingList: postingsToUpdateResponsible }
          });
          sendTrackingInfo('Panel', 'Mis avisos', 'Bulk-Cambiar responsable');
        }}
        className='insideSelector'
      >
        <SimpleTooltip
          isMobile={device === 'tablet'}
          position='top-center'
          text={t('panel.bar.select.actions.responsible')}
        >
          <BulkActionIconContainer device={device}>
            <BulkActionIcon action='responsible' width='24px' height='24px' />
          </BulkActionIconContainer>
        </SimpleTooltip>
        {device === 'tablet' && <BulkActionText>{t('panel.bar.select.actions.responsible')}</BulkActionText>}
      </BulkActionContainer>
    );
  }
  return null;
};

export default UpdateResponsible;
